import { takeLatest, put, call } from "redux-saga/effects";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

import {
  FETCH_EVALUATIONS_REQUEST,
  FETCH_EVALUATIONS_SUCCESS,
  FETCH_EVALUATIONS_FAILURE,
  SAVE_EVALUATION_REQUEST,
  SAVE_EVALUATION_SUCCESS,
  SAVE_EVALUATION_FAILURE,
  CHANGE_EVALUATION_STATUS_REQUEST,
  CHANGE_EVALUATION_STATUS_SUCCESS,
  CHANGE_EVALUATION_STATUS_FAILURE,
} from "./actionTypes";

function* fetchEvaluationsSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(
      post,
      process.env.REACT_APP_Fetch_MASTER_EVALUATION,
      formData
    );

    yield put({ type: FETCH_EVALUATIONS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Fetch Evaluations Error:", error);
    yield put({
      type: FETCH_EVALUATIONS_FAILURE,
      payload: error.message,
    });
  }
}

function* saveEvaluationSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_MASTER_EVALUATION,
      action.payload
    );

    const message = response?.message || response?.Msg || response?.msg;
    const isError = message?.includes("Already Exists") || message?.includes("already exists") || 
                    message?.includes("Exists") || message?.includes("exists");
    const isSuccess = !isError && (response?.status === "success" || 
                      message?.includes("Successfully") || message?.includes("successfully"));

    if (isSuccess) {
      yield put({ type: SAVE_EVALUATION_SUCCESS, payload: response });
      Swal.fire("Success", message, "success");
    } else {
      yield put({ type: SAVE_EVALUATION_FAILURE, payload: message });
      Swal.fire("Error", message || "Failed to save evaluation!", "error");
    }
  } catch (error) {
    console.error("Save Evaluation Error:", error);
    yield put({ type: SAVE_EVALUATION_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

function* changeEvaluationStatusSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_STATUSCHANGE_MASTER_EVALUATION,
      action.payload
    );

    const message = response?.message || response?.Msg || response?.msg;
    const isSuccess = response?.status === "Success" || response?.status === "success" || 
                      message?.includes("Successfully") || message?.includes("successfully");

    if (isSuccess) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: message || "Operation completed successfully!",
      });
      yield put({ type: CHANGE_EVALUATION_STATUS_SUCCESS, payload: response });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: message || "Failed to update evaluation status!",
      });
      yield put({ type: CHANGE_EVALUATION_STATUS_FAILURE, payload: message });
    }
  } catch (error) {
    yield put({ type: CHANGE_EVALUATION_STATUS_FAILURE, payload: error.message });
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message,
    });
  }
}

export default function* evaluationMasterSaga() {
  yield takeLatest(FETCH_EVALUATIONS_REQUEST, fetchEvaluationsSaga);
  yield takeLatest(SAVE_EVALUATION_REQUEST, saveEvaluationSaga);
  yield takeLatest(CHANGE_EVALUATION_STATUS_REQUEST, changeEvaluationStatusSaga);
}
